export default class Howto {
    constructor() {
        this.init();
    }

    init() {
        this.setEvents();
    }

   setEvents(){
        $('.howto__close').on('click',function(){
            //TweenLite.to('.howto',0.5,{opacity:0,display:'none'});
            document.body.classList.remove("-inmodal");
        });
        $('.shoulder_logo').on('click',function(){
            //TweenLite.to('.howto',0.5,{opacity:1,display:'block'});
            document.body.classList.add("-inmodal");
        });

    }

}